import authMiddleware from '@Router/middlewares/middleware.auth.js';
import accessMiddleware from '@Router/middlewares/middleware.access.js';
import routes from '@Router/routes.js';
import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const router = new Router(routes);

router.beforeEach(authMiddleware);
router.beforeEach(accessMiddleware);

export default router;
